<template>
  <div class="result">
    <h3 class="result-title">测试得分</h3>
    <div
      class="grade"
      :class="result.score >= result.pass_score ? 'blueColor' : 'redColor'"
    >
      {{ result.score }}
    </div>
    <h3 class="total">
      总分:{{ result.total_score }}
      <span class="msg">及格分:{{ result.pass_score }}</span>
    </h3>
    <h3 class="total">
      {{
        result.score >= result.pass_score
          ? '恭喜，您通过了考试'
          : '很遗憾，您没有通过考试'
      }}
    </h3>
    <el-card class="box-card" shadow="always">
      <div class="text">
        答对<span class="greColor">{{ result.right_sum }}</span
        >道题（+<span class="greColor">{{ result.score }}</span
        >分）
      </div>
      <div class="text orgColor">
        答错<span class="orgColor">{{ result.wrong_sum }}</span
        >道题
      </div>
      <div class="text yelColor">
        漏答<span class="yelColor">{{ result.leakage_sum }}</span
        >道题
      </div>
      <el-button
        type="primary"
        v-if="type != 2 && type != 1"
        @click="checkPaper"
        >查看试卷</el-button
      >
      <!-- <el-button type="primary" v-if="type!=2&&result.score<result.pass_score" @click="resetPaper">重做</el-button> -->
      <el-button
        type="primary"
        v-if="type != 2 && is_repeat == 1"
        @click="resetPaper"
        >重做</el-button
      >
    </el-card>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Result',
  props: ['result', 'type', 'is_repeat'],
  created() {},
  methods: {
    checkPaper() {
      this.$emit('checkPaper')
    },
    resetPaper() {
      this.$emit('resetPaper', this.result.score)
    },
  },
}
</script>
<style lang="less" scoped>
.blueColor {
  color: #1890ff;
}
.redColor {
  color: #f55e6e;
}
.msg {
  margin-left: 20px;
}
.result {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  background-image: url('../../../admin/assets/images/result-bg.jpg');
  background-size: 100% 100%;
  height: 100%;
  width: 100%;
  background-color: #fff;
  text-align: center;
  z-index: 99;
  .result-title,
  .total {
    color: #fff;
    font-weight: normal;
  }
  .total {
    font-size: 14px;
  }
  .grade {
    margin: 0px auto;
    width: 150px;
    height: 150px;
    line-height: 150px;
    font-size: 50px;
    background-image: url('../../../admin/assets/images/Group.png');
    background-size: 100%, 100%;
  }
  .box-card {
    margin: 0 10px;
    .text {
      font-size: 18px;
      font-weight: bolder;
      letter-spacing: 1px;
      padding: 10px 0;
      .orgColor {
        color: #f55e6e;
      }
      .greColor {
        color: #29b084;
      }
      .yelColor {
        color: #ff7a45;
      }
    }
  }
}
</style>
